<script setup lang="ts">
/**
 * Loading spinner component.
 *
 * @component LoadingSpinner
 */

withDefaults(
  defineProps<{
    /**
     * Spinner size.
     */
    size?: 'small' | 'medium' | 'large'

    /**
     * Loading text.
     */
    text?: string
  }>(),
  {
    size: 'medium',
  }
)
</script>

<template>
  <div :class="['loading-spinner', `size-${size}`]">
    <div class="spinner" />
    <span v-if="text" class="loading-text">{{ text }}</span>
  </div>
</template>